import moment from 'moment';

const formatHistoryDate = (date: string | Date) =>
  moment(date).format('MMM Do YYYY · h:mm A');

export default formatHistoryDate;
